import React from 'react';



export default function CHIPS({ description, disabled, label, onChange, options, value }) {

    //  event functions ------------------------------------------------------------------------------------------------

    function onClick_button(var_value) {
        var_value !== value && onChange && onChange(var_value);
    }


    // RENDER ==========================================================================================================

    return (
        <div className='field__wrapper'>
            <div className='field__label medium'>{label}</div>
            <div className='chip__wrapper'>
                {options.map((item, index) =>
                    <div key={index} className={'chip' + (value === item.value ? ' active' : '')} onClick={() => onClick_button(item.value)}>{item.text}</div>
                )}
            </div>
            {description && <div className='field__description text--sm normal color--gray--600'>{description}</div>}
        </div>
    );

};